'use client';
import parse from 'html-react-parser';
import moment from 'moment';
import {useTranslations} from 'next-intl';

export default function Template(Prop: {moduleOption: any; moduleData?: any}) {
  const options = Prop.moduleOption || {};
  const templateItems = Prop.moduleData?.items ?? options?.items ?? [];
  const tDate = useTranslations('Date');

  // Extensible formatting helper registry. Add new helpers here.
  const dateHandler = (val: any, format: string) => {
    if (!val) return '';
    const date = moment(val);
    if (!date.isValid()) return String(val);

    if (tDate) {
      const weekday = {
        Monday: tDate('Monday'),
        Tuesday: tDate('Tuesday'),
        Wednesday: tDate('Wednesday'),
        Thursday: tDate('Thursday'),
        Friday: tDate('Friday'),
        Saturday: tDate('Saturday'),
        Sunday: tDate('Sunday')
      };
      let formatted = date.format(format);
      const englishWeekday = date.format('dddd');
      if (weekday[englishWeekday as keyof typeof weekday]) {
        formatted = formatted.replace(
          englishWeekday,
          weekday[englishWeekday as keyof typeof weekday]
        );
      }
      return formatted;
    }
    return date.format(format);
  };

  const helpers: Record<string, (val: any) => string> = {
    date: (val: any) => {
      return dateHandler(val, tDate('dateFormat') || 'YYYY-MM-DD');
    },
    postAt: (val: any) => {
      return dateHandler(val, tDate('dateFormatLong') || 'YYYY-MM-DD');
    },
    uppercase: (val: any) => {
      return String(val ?? '').toUpperCase();
    },
    lowercase: (val: any) => {
      return String(val ?? '').toLowerCase();
    },
    urlTarget: (val: any) => {
      return val?.match(/^https?:\/\/.*/) ? '_blank' : '_self';
    }
  };

  const container = options?.container;
  const formTemplate = (templateItem: any) => {
    let template = options?.template ?? '';

    // Regex to match optional helper/prefix and key path, e.g. {date:posted_at} or {thumbnail.url}
    const regex =
      /\{(?:([A-Za-z0-9_]+):)?([A-Za-z0-9_]+(?:\.[A-Za-z0-9_]+)*)\}/g;
    const matches = Array.from(template.matchAll(regex));
    for (const match of matches as RegExpExecArray[]) {
      const fullMatch = match[0];
      const prefix = match[1];
      const keyPath = match[2];

      // get data with dot path
      let data = templateItem;
      keyPath.split('.').forEach((k) => {
        if (!data) return;
        data = data?.[k.trim()];
      });

      // Apply helper if prefix is provided and helper exists
      let formattedData = data;
      if (prefix && helpers[prefix]) {
        formattedData = helpers[prefix](data);
      }

      const displayValue =
        formattedData !== undefined && formattedData !== null
          ? String(formattedData)
          : '';
      template = template.replaceAll(fullMatch, displayValue);
    }
    return template;
  };

  if (container) {
    return parse(
      container.replaceAll('{items}', templateItems.map(formTemplate).join(''))
    );
  }
  return (
    <div className={options?.class}>
      {templateItems.map((templateItem: any, index: number) => (
        <div key={index} className={options?.itemclass}>
          {parse(formTemplate(templateItem))}
        </div>
      ))}
    </div>
  );
}
